import {
    Box,
    Button,
    ButtonGroup,
    Card,
    CardActions,
    CardContent,
    Divider,
    Grid,
    TextField,
    ToggleButton,
    ToggleButtonGroup
} from "@mui/material";
import Add from "@mui/icons-material/Add";
import Remove from "@mui/icons-material/Remove";
import React, {useState} from "react";
import {useAuth0} from "@auth0/auth0-react";
import getApiEndpoint from "../utils/apiUtils";
import {useNavigate} from "react-router";

function DoughCalculator() {
    const {getAccessTokenSilently} = useAuth0();

    const [ballCountStr, setBallCountStr] = useState('3');
    const onChangeBallCount = (event: any) => {
        const newValue = event.target.value;
        if (newValue === '' || (parseInt(newValue) > 0 && !isNaN(newValue))) {
            setBallCountStr(newValue);
        }
    };

    const handleBallCountIncrease = () => {
        setBallCountStr((prevCount) => (parseInt(prevCount) + 1).toString());
    };

    const handleBallCountDecrease = () => {
        setBallCountStr((prevCount) => {
            const newCount = parseInt(prevCount) - 1;
            return newCount > 0 ? newCount.toString() : prevCount;
        });
    };

    const [ballSize, setBallSize] = useState('260');
    const handleBallSizeChange = (event: any, newSize: any) => {
        setBallSize(newSize);
    };

    const [hydrationPercentageStr, setHydrationPercentageStr] = useState('65.00');
    const onHydrationPercentageChange = (event: any) => {
        const newValue = event.target.value;
        if (newValue === '' || (parseFloat(newValue) >= 55 && parseFloat(newValue) <= 75)) {
            setHydrationPercentageStr(newValue);
        }
    };

    const handleHydrationPercentageIncrease = () => {
        setHydrationPercentageStr((prevPercentage) => {
            const newVal = parseFloat(prevPercentage) + 1.0;
            return newVal <= 75 ? newVal.toFixed(2) : prevPercentage;
        });
    };

    const handleHydrationPercentageDecrease = () => {
        setHydrationPercentageStr((prevPercentage) => {
            const newPercentage = parseFloat(prevPercentage) - 1.0;
            return newPercentage >= 55 ? newPercentage.toFixed(2) : prevPercentage;
        });
    };

    const [yeastPercentageStr, setYeastPercentageStr] = useState('0.1');
    const onChangeYeastPercentage = (event: any) => {
        const newValue = event.target.value;
        if (newValue === '' || (parseFloat(newValue) >= 0.05 && parseFloat(newValue) <= 0.4)) {
            setYeastPercentageStr(newValue);
        }
    };

    const handleYeastPercentageIncrease = () => {
        setYeastPercentageStr((prevPercentage) => {
            const newVal = parseFloat(prevPercentage) + 0.025;
            return newVal <= 0.4 ? newVal.toFixed(3) : prevPercentage;
        });
    };

    const handleYeastPercentageDecrease = () => {
        setYeastPercentageStr((prevPercentage) => {
            const newPercentage = parseFloat(prevPercentage) - 0.025;
            // account for floating point precision
            return newPercentage >= 0.049 ? newPercentage.toFixed(3) : prevPercentage;
        });
    };

    const [yeastType, setYeastType] = useState('fresh');
    const handleYeastTypeChange = (event: any, newType: any) => {
        setYeastType(newType);
    };

    const [saltPercentageStr, setSaltPercentageStr] = useState('2.5');
    const onSaltPercentageChange = (event: any) => {
        const newValue = event.target.value;
        if (newValue === '' || (parseFloat(newValue) >= 1.5 && parseFloat(newValue) <= 3.5)) {
            setSaltPercentageStr(newValue);
        }
    };

    const handleSaltPercentageIncrease = () => {
        setSaltPercentageStr((prevPercentage) => {
            const newVal = parseFloat(prevPercentage) + 0.25;
            return newVal <= 3.5 ? newVal.toFixed(2) : prevPercentage;
        });
    };

    const handleSaltPercentageDecrease = () => {
        setSaltPercentageStr((prevPercentage) => {
            const newPercentage = parseFloat(prevPercentage) - 0.25;
            return newPercentage >= 1.5 ? newPercentage.toFixed(2) : prevPercentage;
        });
    };

    const [oilPercentageStr, setOilPercentageStr] = useState('0.0');
    const onOilPercentageChange = (event: any) => {
        const newValue = event.target.value;
        if (newValue === '' || (parseFloat(newValue) >= 0.0 && parseFloat(newValue) <= 5.0)) {
            setOilPercentageStr(newValue);
        }
    };

    const handleOilPercentageIncrease = () => {
        setOilPercentageStr((prevPercentage) => {
            const newVal = parseFloat(prevPercentage) + 0.25;
            return newVal <= 5.0 ? newVal.toFixed(2) : prevPercentage;
        });
    };

    const handleOilPercentageDecrease = () => {
        setOilPercentageStr((prevPercentage) => {
            const newPercentage = parseFloat(prevPercentage) - 0.25;
            return newPercentage >= 0.0 ? newPercentage.toFixed(2) : prevPercentage;
        });
    };

    const navigate  = useNavigate();

    const callDoughCalculate = async () => {
        const token = await getAccessTokenSilently();
        const origin = getApiEndpoint();
        const response = await fetch(`${origin}/api/dough`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                ballCount: parseInt(ballCountStr),
                ballSize: parseInt(ballSize),
                hydrationPercentage: parseFloat(hydrationPercentageStr),
                yeastPercentage: parseFloat(yeastPercentageStr),
                yeastType: yeastType,
                saltPercentage: parseFloat(saltPercentageStr),
                oilPercentage: parseFloat(oilPercentageStr),
            }),
        });

        if (response.ok) {
            const data = await response.json();
            console.log("json", JSON.stringify(data));
            navigate('/recipe', {state: {doughRecipe: data}});

        } else {
            console.error('Error calculating dough');
        }
    };

    return (
        <Card
            variant="elevation"
            sx={{
                display: "inline-block",
                m: 2
            }}
        >
            <CardContent>
                <Grid container spacing={2} alignItems={"center"}>
                    <Grid item xs={6} md={6}>
                        <TextField
                            sx={{mr: 2}}
                            required={true}
                            variant={"filled"}
                            label={"Ballenanzahl"}
                            value={ballCountStr}
                            onChange={onChangeBallCount}
                            error={ballCountStr !== '' && parseInt(ballCountStr) <= 0}
                            helperText={"Min. 1 Ballen"}
                        />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <ButtonGroup variant="outlined" aria-label="Basic button group">
                            <Button onClick={handleBallCountIncrease}><Add/></Button>
                            <Button onClick={handleBallCountDecrease}><Remove/></Button>
                        </ButtonGroup>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <ToggleButtonGroup
                            sx={{
                                width: 'auto',        // Set the desired width
                                margin: '0 auto',     // Center the ToggleButtonGroup
                                display: 'flex',
                            }}
                            value={ballSize}
                            onChange={handleBallSizeChange}
                            exclusive={true}>
                            <ToggleButton value={"245"} size={"small"}>S (245g)</ToggleButton>
                            <ToggleButton value={"260"} size={"small"}>M (260g)</ToggleButton>
                            <ToggleButton value={"275"} size={"small"}>L (275g)</ToggleButton>
                        </ToggleButtonGroup>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Divider variant={"middle"}/>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <Box alignItems="baseline" display={"flex"} gap={2}>
                            <TextField
                                sx={{mr: 2, minWidth: "fit-content"}}
                                required={true}
                                variant={"filled"}
                                label={"Hydration (%)"}
                                value={hydrationPercentageStr}
                                onChange={onHydrationPercentageChange}
                                error={hydrationPercentageStr !== '' && (parseFloat(hydrationPercentageStr) < 55 || parseFloat(hydrationPercentageStr) > 75)}
                                helperText={"55% bis 75%"}
                            />
                            <ButtonGroup variant="outlined" aria-label="Basic button group">
                                <Button onClick={handleHydrationPercentageIncrease}><Add/></Button>
                                <Button onClick={handleHydrationPercentageDecrease}><Remove/></Button>
                            </ButtonGroup>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Divider variant={"middle"}/>
                    </Grid>
                    <Grid item xs={6} md={12}>
                        <TextField
                            sx={{mr: 2}}
                            required={true}
                            variant={"filled"}
                            label={"Hefe (%)"}
                            value={yeastPercentageStr}
                            onChange={onChangeYeastPercentage}
                            error={yeastPercentageStr !== '' && (parseFloat(yeastPercentageStr) < 0.05 || parseFloat(yeastPercentageStr) > 0.4)}
                            helperText={"0,05% bis 0.4%"}
                        />
                    </Grid>
                    <Grid item xs={6} md={12}>
                        <ButtonGroup variant="outlined" aria-label="Basic button group">
                            <Button onClick={handleYeastPercentageIncrease}><Add/></Button>
                            <Button onClick={handleYeastPercentageDecrease}><Remove/></Button>
                        </ButtonGroup>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <ToggleButtonGroup
                            value={yeastType}
                            onChange={handleYeastTypeChange}
                            exclusive={true}>
                            <ToggleButton value={"activeDry"} size={"small"}>Trocken</ToggleButton>
                            <ToggleButton value={"fresh"} size={"small"}>Frisch</ToggleButton>
                        </ToggleButtonGroup>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Divider variant={"middle"}/>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <TextField
                            sx={{mr: 2}}
                            required={true}
                            variant={"filled"}
                            label={"Salz (%)"}
                            value={saltPercentageStr}
                            onChange={onSaltPercentageChange}
                            error={saltPercentageStr !== '' && (parseFloat(saltPercentageStr) < 1.5 || parseFloat(yeastPercentageStr) > 3.5)}
                            helperText={"Von 1,5% bis 3,5%"}
                        />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <ButtonGroup variant="outlined" aria-label="Basic button group">
                            <Button onClick={handleSaltPercentageIncrease}><Add/></Button>
                            <Button onClick={handleSaltPercentageDecrease}><Remove/></Button>
                        </ButtonGroup>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Divider variant={"middle"}/>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <TextField
                            sx={{mr: 2}}
                            required={true}
                            variant={"filled"}
                            label={"Öl (%)"}
                            value={oilPercentageStr}
                            onChange={onOilPercentageChange}
                            error={oilPercentageStr !== '' && (parseFloat(oilPercentageStr) < 0.0 || parseFloat(yeastPercentageStr) > 5.0)}
                            helperText={"Von 0,0% bis 5,0%"}
                        />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <ButtonGroup variant="outlined" aria-label="Basic button group">
                            <Button onClick={handleOilPercentageIncrease}><Add/></Button>
                            <Button onClick={handleOilPercentageDecrease}><Remove/></Button>
                        </ButtonGroup>
                    </Grid>
                </Grid>
            </CardContent>
            <CardActions>
                <Button onClick={callDoughCalculate} variant={"contained"}>Teig berechnen</Button>
            </CardActions>
        </Card>
    );
}

export default DoughCalculator;